module.exports = __webpack_public_path__ + "static/media/Xero-auto-import-invoices.21888f0d.png";